var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVotedWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666199 8.3332H3.33287V12.9999C3.33287 13.1767 3.4031 13.3463 3.52813 13.4713C3.65315 13.5963 3.82272 13.6665 3.99953 13.6665H7.99953C8.17634 13.6665 8.34591 13.5963 8.47094 13.4713C8.59596 13.3463 8.6662 13.1767 8.6662 12.9999V8.3332H11.3329C11.4584 8.33299 11.5813 8.29738 11.6875 8.23048C11.7937 8.16357 11.8788 8.06807 11.9332 7.95495C11.9876 7.84182 12.0089 7.71566 11.9948 7.59094C11.9808 7.46623 11.9318 7.34801 11.8535 7.24987L6.5202 0.583203C6.2662 0.266536 5.73287 0.266536 5.47887 0.583203L0.145532 7.24987C0.0672913 7.34801 0.0183127 7.46623 0.00422021 7.59094C-0.00987225 7.71566 0.0114927 7.84182 0.0658619 7.95495C0.120231 8.06807 0.2054 8.16357 0.311591 8.23048C0.417781 8.29738 0.540688 8.33299 0.666199 8.3332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotedWhiteIcon);
export default __webpack_public_path__ + "static/media/voted_white_icon.67f4b3a3aa64abe1204818b113a3f14a.svg";
export { ForwardRef as ReactComponent };